
import React, { useEffect, useState } from 'react';
import styles from './index.module.scss';

function VideoPanel(props)
{
    //===========================================================================
    useEffect(() => {
        componentDidMount();
        return componentWillUnmount;
    }, []);
    //===========================================================================

    function componentDidMount()
    {
    }

    function componentDidUpdate()
    {

    }
    function componentWillUnmount()
    {
        
    }

    function render()
    {
        return (
            <div id={props.info.id} className={styles.videoPanel}>
                <iframe id={props.info.iframe} className={styles.fill}></iframe>
            </div>
        );
    }

    return render();
}

export default VideoPanel;